import { render, staticRenderFns } from "./RoomsPage.vue?vue&type=template&id=2f097790&scoped=true&"
import script from "./RoomsPage.vue?vue&type=script&lang=js&"
export * from "./RoomsPage.vue?vue&type=script&lang=js&"
import style0 from "./RoomsPage.vue?vue&type=style&index=0&id=2f097790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f097790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
installComponents(component, {VCarousel,VCarouselItem,VRangeSlider})
